var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M7.5 2.094a6.406 6.406 0 1 1 0 12.812 6.406 6.406 0 0 1 0-12.812zm.01 1.392-.19.005a4.979 4.979 0 0 0-3.344 1.487 4.982 4.982 0 1 0 7.048 7.044 4.983 4.983 0 0 0-3.325-8.533l-.19-.003zM7.5 7.458c.485 0 .878.393.878.878v2.862a.878.878 0 1 1-1.756 0V8.336c0-.485.393-.878.878-.878zm0-2.524a1.024 1.024 0 1 1 0 2.049 1.024 1.024 0 0 1 0-2.049z"
  })));
};
export default SvgInfo;